import { inject } from 'inversify';
import EventEmitter from 'wolfy87-eventemitter';
import { POPOVER_MODULE_IDS } from './popover.types';
import type { IPopoverController, IPopoverEvents } from './popover.interface';

export class PopoverController extends EventEmitter implements IPopoverController {
  @inject(POPOVER_MODULE_IDS.POPOVER_EVENTS) public events: IPopoverEvents;

  state: {
    isHidden: boolean;
    data: {
      title: string;
      text: string;
      x: number;
      y: number;
      offset: number;
      seat?: {
        id: number;
      };
    };
  };

  constructor() {
    super();

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);

    this.state = {
      isHidden: true,
      data: {
        title: null,
        text: null,
        x: null,
        y: null,
        offset: 40,
      },
    };
  }

  show(data: any) {
    const { offset, ...rest } = data;
    this.state = {
      isHidden: false,
      data: {
        ...rest,
        offset: offset || 40, // TODO: magik number
      },
    };

    this.emit(this.events.UPDATE, this.state);
  }

  move({ x, y }) {
    this.emit(this.events.MOVE, { x, y });
  }

  hide() {
    this.state = {
      isHidden: true,
      data: null,
    };

    this.emit(this.events.UPDATE, this.state);
  }
}
